import { useState, useEffect } from "react";
import { Routes, Route, useLocation } from "react-router-dom";
import { useSesion } from "./contextSesion";
import { ElHome } from "../pages/panel_home";
import { ElLoader } from "../componentes/pantallaCarga";
import { Footer } from "../componentes/footer";
import { Header } from "../componentes/header";


export const CompGeneral = () => {
  const { sesion } = useSesion();
  const location = useLocation();
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const handleStart = () => setIsLoading(true);
    const handleComplete = () => setIsLoading(false);

    handleStart();
    const timeout = setTimeout(handleComplete, 500); // Simula un tiempo de carga

    return () => clearTimeout(timeout);
  }, [location.pathname]);

  return (
    <>
    <Header />
    <div  className="contenedor-central">
          {isLoading ? (
            <div className="contenedor_carga">
            <ElLoader />
            </div>
          ) : (
            <Routes>
              <Route path="/panel" element={<ElHome sesion={sesion}/>} />
              <Route path="*" element={"NoEncontrado"} />
            </Routes>
          )}
    </div>
    <Footer />
    </>
    
  );
};
